// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  resolveActorLabel,
  formatAuditDate,
  formatAuditTime,
  humanizeAuditEntry,
  AUDIT_TONE_CLASSES,
} from "@/legacy/helpersModule";
import { Button, Input } from "@/shared/components/ui";
import { useEscapeKey } from "@/shared/hooks/useEscapeKey";
export function AuditLogView({ auditLog, candidates, auditCandidateNames, hrUsers, onRefresh, onBack }) {
  useEscapeKey(onBack);
  const [filter, setFilter] = useState("");
  const candidatesMap = useMemo(() => {
    const fromList = Object.fromEntries((candidates || []).map((c) => [c.id, c.name]));
    return { ...(auditCandidateNames || {}), ...fromList };
  }, [candidates, auditCandidateNames]);
  const hrUsersMap = hrUsers || {};
  const rows = useMemo(
    () =>
      (auditLog || []).map((a) => ({
        entry: a,
        humanized: humanizeAuditEntry(a, hrUsersMap, candidatesMap),
        actorLabel: resolveActorLabel(a.actor, hrUsersMap, candidatesMap),
        dateLabel: formatAuditDate(a.timestamp),
        timeLabel: formatAuditTime(a.timestamp),
      })),
    [auditLog, hrUsersMap, candidatesMap],
  );
  const q = filter.trim().toLowerCase();
  const filtered = q
    ? rows.filter((r) =>
        `${r.humanized.label} ${r.actorLabel} ${r.entry.action} ${r.humanized.sentence} ${r.dateLabel} ${r.timeLabel}`
          .toLowerCase()
          .includes(q),
      )
    : rows;
  const sorted = [...filtered].sort((a, b) => new Date(b.entry.timestamp) - new Date(a.entry.timestamp));
  return (
    <div className="min-h-dvh safe-bottom bg-surface-alt">
      <div className="bg-white border-b border-line text-ink-900 px-4 sm:px-6 py-3 sm:py-4 safe-top safe-x flex flex-wrap items-center gap-2 sm:gap-3">
        <button onClick={onBack} className="text-ink-400 hover:text-ink-900 text-sm">← Back</button>
        <span className="font-bold">Audit Log</span>
        <span className="text-xs text-brand-700 bg-brand-50 px-2 py-0.5 rounded-full">{auditLog.length}</span>
        {onRefresh ? <Button type="button" variant="secondary" size="sm" onClick={onRefresh} className="w-full sm:w-auto sm:ml-auto">↻ Refresh names</Button> : null}
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 sm:py-8 safe-x">
        <h1 className="text-2xl sm:text-3xl font-black text-ink-900 mb-1">Access & Action Audit</h1>
        <Input value={filter} onChange={e => setFilter(e.target.value)} placeholder="Filter by name, action, application, date…" className="mb-5 shadow-sm"/>
        {sorted.length === 0 ? <div className="bg-white rounded-2xl border-2 border-dashed border-line py-16 text-center"><p className="text-ink-400">No entries.</p></div> : (
          <div className="space-y-2">{sorted.map(({ entry: a, humanized: h, actorLabel, dateLabel, timeLabel }) => (
            <div key={a.id} className="bg-white border border-line rounded-xl p-4 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 sm:gap-3">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className={`text-xs font-black px-2 py-0.5 rounded ${AUDIT_TONE_CLASSES[h.tone] || AUDIT_TONE_CLASSES.slate}`}>{h.label}</span>
                  <span className="text-xs font-bold text-ink-600">{actorLabel}</span>
                  <span className="text-[10px] text-ink-400 font-mono bg-surface-alt border border-line rounded px-1.5 py-0.5">{a.action}</span>
                </div>
                <p className="text-sm text-ink-600">{h.sentence}</p>
              </div>
              <div className="text-left sm:text-right shrink-0 border-t border-line sm:border-0 pt-2 sm:pt-0">
                <p className="text-xs text-ink-400">{dateLabel}</p>
                <p className="text-xs text-ink-400">{timeLabel}</p>
              </div>
            </div>
          ))}</div>
        )}
      </div>
    </div>
  );
}

const CV_ANALYSER_MAX = 20;
const CV_ANALYSER_MB = 5;

